import { API } from '~/app/routes';
import { fetch } from '~/store/commonStore';
import {
  AllUsers,
  Department,
  IssueCategory,
  IssueSortingType,
  Label,
} from '~/types';
import { assertOnlineForRemote } from './remoteGuard';

export class AppReferenceRemoteDataSource {
  fetchUsers(): Promise<AllUsers[]> {
    assertOnlineForRemote();
    return fetch<AllUsers>(`${API.allUsers}`);
  }

  fetchDepartments(): Promise<Department[]> {
    assertOnlineForRemote();
    return fetch<Department>(`${API.derpartments}`);
  }

  fetchIssueCategories(): Promise<IssueCategory[]> {
    assertOnlineForRemote();
    return fetch<IssueCategory>(`${API.issue}/categories`);
  }

  fetchIssueSortingTypes(): Promise<IssueSortingType[]> {
    assertOnlineForRemote();
    return fetch<IssueSortingType>(`${API.issue}/sorting-types`);
  }

  fetchIssueLabels(): Promise<Label[]> {
    assertOnlineForRemote();
    return fetch<Label>(`${API.issue}/get_labels`);
  }
}

export const appReferenceRemote = new AppReferenceRemoteDataSource();
